import { render } from "./FillWordExerciseComponent.vue?vue&type=template&id=57163d26&scoped=true"
import script from "./FillWordExerciseComponent.vue?vue&type=script&lang=js"
export * from "./FillWordExerciseComponent.vue?vue&type=script&lang=js"

import "./FillWordExerciseComponent.vue?vue&type=style&index=0&id=57163d26&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57163d26"]])

export default __exports__